var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "circle-arrow",
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 86,
    fill: "none",
    stroke: "white",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62 132 L135 67",
    fill: "none",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92 61 L135 67 L140 119",
    fill: "none",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoArrow);
export default __webpack_public_path__ + "static/media/videoArrow.e2713c76a4a3482a38e4a6643fce5243.svg";
export { ForwardRef as ReactComponent };